import httpApi from "@src/utils/httpApi";

type ChatTokenResponse = {
  token: string;
  sessionExpirationTime: string;
  tokenExpirationTime: string;
};

const parseChatTokenResponse = (payload: unknown): ChatTokenResponse => {
  const data = (payload as { data?: ChatTokenResponse })?.data ?? payload;
  const token = (data as ChatTokenResponse)?.token;
  if (!token) {
    throw new Error("Invalid chat token response");
  }
  return data as ChatTokenResponse;
};

export const getChatHistory = async (conversationId: string) => {
  try {
    const response = await httpApi.get(
      `/api/curator-conversations/${conversationId}/history`
    );
    return response.data.data || [];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error fetching chat history", error);
    return [];
  }
};

export const getChatToken = async (
  conversationId: string
): Promise<ChatTokenResponse> => {
  try {
    const response = await httpApi.post(
      `/api/curator-conversations/${conversationId}/token`
    );
    return parseChatTokenResponse(response.data);
  } catch (error: any) {
    const apiMessage =
      error?.response?.data?.error?.message ||
      error?.response?.data?.message ||
      error?.message;
    // eslint-disable-next-line no-console
    console.error("Error fetching chat token", apiMessage || error);
    throw new Error(apiMessage || "Failed to fetch chat token");
  }
};

export const getEventsToken = async (): Promise<ChatTokenResponse> => {
  try {
    const response = await httpApi.post(
      "/api/curator-conversations/events-token"
    );
    return parseChatTokenResponse(response.data);
  } catch (error: any) {
    const apiMessage =
      error?.response?.data?.error?.message ||
      error?.response?.data?.message ||
      error?.message;
    // eslint-disable-next-line no-console
    console.error("Error fetching events token", apiMessage || error);
    throw new Error(apiMessage || "Failed to fetch events token");
  }
};
